import type { HorizontalLineBlock, SlateBlock } from '@atlas/renderer';
import { Editor, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import getNode from '@atlas/tool/box/slate/getNode';
import isTableBlock from '@atlas/tool/box/slate/isTableBlock';
import isVoidBlock from '@atlas/tool/box/slate/isVoidBlock';
import removeTopLevelBlocks from '@atlas/tool/box/slate/removeTopLevelBlocks';
import areBlockLeavesEmpty from '@atlas/tool/box/slate/areBlockLeavesEmpty';
import changeEditorSelection from '@atlas/tool/box/slate/changeEditorSelection';

export default function insertHorizontalLine(editor: Editor) {
    // TODO: @Stan add Up & Down navigation for Void blocks

    const horizontalLineBlock: HorizontalLineBlock = {
        type: 'horizontal-line',
        children: [{ text: '' }],
    };

    ReactEditor.focus(editor);

    const block = editor.selection && getNode<SlateBlock>(editor, [editor.selection.focus.path[0]]);

    if (!block || !editor.selection) {
        const index = editor.children.length;
        Transforms.insertNodes(editor, horizontalLineBlock, {
            at: [index],
        });
        const focus = { offset: 0, path: [index, 0] };
        changeEditorSelection(editor, { anchor: focus, focus });
        return;
    }

    const { focus } = editor.selection;

    if (isTableBlock(block)) return;

    if (!isVoidBlock(block) && areBlockLeavesEmpty(block)) {
        removeTopLevelBlocks(editor, focus.path[0]);
        Transforms.insertNodes(editor, horizontalLineBlock, {
            at: [focus.path[0]],
        });

        if (focus.path[0] < editor.children.length - 2) {
            const newFocus = Editor.start(editor, [focus.path[0] + 1]);
            changeEditorSelection(editor, { anchor: newFocus, focus: newFocus });
        } else {
            const newFocus = { offset: 0, path: [focus.path[0], 0] };
            changeEditorSelection(editor, { anchor: newFocus, focus: newFocus });
        }

        return;
    }

    Transforms.insertNodes(editor, horizontalLineBlock, {
        at: focus,
        mode: 'highest',
    });

    if (editor.children.length > focus.path[0] + 2) {
        const newFocus = Editor.start(editor, [focus.path[0] + 2]);
        changeEditorSelection(editor, { anchor: newFocus, focus: newFocus });
    } else if (editor.children.length > focus.path[0] + 1) {
        const newFocus = Editor.start(editor, [focus.path[0] + 1]);
        changeEditorSelection(editor, { anchor: newFocus, focus: newFocus });
    } else {
        const newFocus = { offset: 0, path: [focus.path[0], 0] };
        changeEditorSelection(editor, { anchor: newFocus, focus: newFocus });
    }
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('insertHorizontalLine', () => {
        it.todo('🤷🏼');
    });
}

// #endregion
